var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selector',{ref:"selector",attrs:{"name":_vm.formatNameWording,"shouldSelectSingleSourceAutomatically":true}})}
var staticRenderFns = []

export { render, staticRenderFns }